import { Outlet } from "react-router-dom";

export const Communication = () => {
    return (
        <>
            <Outlet />
        </>
    )
}
